import { merge } from 'lodash';
import { bianka } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { Click, ClickType, ElementType, Impression } from '@fiverr-private/bianka_js';

const PAGE_NAME = 'tailored_homepage_perseus';

const getBasicData = () => {
    const { pageCtxId, userId, organizationId } = getContext();

    return {
        page: {
            ctxId: pageCtxId,
            name: PAGE_NAME,
        },
        event: {
            organization: {
                id: organizationId as string,
            },
            user: {
                id: userId as number,
            },
        },
    };
};

export const clickedOnScheduleMeeting = () =>
    bianka.reportActivity<Click>(
        merge(getBasicData(), {
            type: Click,
            event: {
                type: 'clicked_on_fiverr_pro_bsm_schedule_a_meeting',
                clickType: ClickType.LEFT,
                element: {
                    name: 'pjp',
                    type: ElementType.BUTTON,
                },
            },
        })
    );

export const clickedOnFindOutMore = () =>
    bianka.reportActivity<Click>(
        merge(getBasicData(), {
            type: Click,
            event: {
                type: 'clicked_on_pjp_schedule_modal_find_out_more',
                clickType: ClickType.LEFT,
                element: {
                    name: 'pjp_schedule_modal_find_out_more',
                    type: ElementType.BUTTON,
                },
            },
        })
    );

export const clickedOnModalClose = () =>
    bianka.reportActivity<Click>(
        merge(getBasicData(), {
            type: Click,
            event: {
                type: 'clicked_on_pjp_schedule_modal_close',
                clickType: ClickType.LEFT,
                element: {
                    name: 'pjp_schedule_modal_close',
                    type: ElementType.BUTTON,
                },
            },
        })
    );

export const viewedPjpScheduleModal = () =>
    bianka.reportActivity<Impression>(
        merge(getBasicData(), {
            type: Impression,
            event: {
                type: 'viewed_pjp_schedule_modal',
                component: {
                    name: 'pjp_schedule_modal',
                    type: 'modal',
                    impId: '',
                    level: 0,
                    isLeaf: false,
                    positionInParent: 0,
                    sizeInParent: 0,
                    visibleThroughScroll: false,
                },
            },
        })
    );
